import { useCallback, useEffect, useState } from "react";

import { emptyString, inboxPageConstants } from "../../../constants";
import { handleAsyncAction } from "../../../../../shared";

const { REPLACE_USERNAME_FROM_AI_RESPONSE } = inboxPageConstants;

/**
 * AI reply modal state and generation handlers for the inbox chat composer.
 */
const useInboxAiResponses = ({
  aiResponse,
  selectedConversation,
  generateAIResponse,
  reGenerateAIResponse,
  resetAiResponse,
  resetBrandSocialLinks,
  sendMessage,
  setInputMessage,
  setFiles,
  setMessage,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Modal toggle.
  const isOpenToggle = useCallback(() => {
    setIsOpen((open) => !open);
  }, []);

  //Send message to server using signalR
  const generateAiResponse = () => {
    isOpenToggle();
    resetAiResponse();
    handleAsyncAction(generateAIResponse(selectedConversation.id), {
      onSuccess: () => {
        setInputMessage(emptyString);
      },
    });
  };

  const reGenerateAiResponse = (responseAction) => {
    reGenerateAIResponse(responseAction, selectedConversation.id);
  };

  const handleSendMessageAndToggleModal = () => {
    sendMessage(true);
    isOpenToggle();
  };

  const handleCloseModalAndResetFields = () => {
    resetAiResponse();
    resetBrandSocialLinks();
    setMessage(emptyString);
    setInputMessage(emptyString);

    setFiles([]);
    isOpenToggle();
  };

  useEffect(() => {
    setMessage(
      aiResponse
        ? aiResponse?.replace(
            REPLACE_USERNAME_FROM_AI_RESPONSE,
            selectedConversation?.customerName,
          )
        : emptyString,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiResponse]);

  return {
    isOpen,
    isOpenToggle,
    generateAiResponse,
    reGenerateAiResponse,
    handleSendMessageAndToggleModal,
    handleCloseModalAndResetFields,
  };
};

export default useInboxAiResponses;
